// frontend/src/app/claim-annotator/ports/pdf-source.port.ts
import { InjectionToken, Signal } from '@angular/core';

export interface PdfSource {
  readonly current: Signal<Blob | string | null>;
  setBlob(blob: Blob, filename: string): void;
  setUrl(url: string): void;
  clear(): void;
}

export const PDF_SOURCE = new InjectionToken<PdfSource>('PDF_SOURCE');
